module.exports = __webpack_public_path__ + "img/icone_checkbox_branco.46726c17.svg";